import * as React from 'react';
import Lottie from 'lottie-react';

import searchingSpinnerAnimation from 'assets/animations/searching-spinner.json';
import { cn } from 'lib/utils';

type LoadingAnimationSize = 'sm' | 'md' | 'lg';

const SIZE_STYLES: Record<LoadingAnimationSize, string> = {
  sm: 'h-16 w-16',
  md: 'h-[7.5rem] w-[7.5rem]',
  lg: 'h-48 w-48',
};

export interface LoadingAnimationProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: LoadingAnimationSize;
}

export const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  size = 'md',
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        'relative inline-flex items-center justify-center overflow-hidden',
        SIZE_STYLES[size],
        className,
      )}
      aria-busy="true"
      role="status"
      aria-live="polite"
      {...props}
    >
      <Lottie
        animationData={searchingSpinnerAnimation}
        autoplay
        loop
        className="h-full w-full"
      />
    </div>
  );
};
